/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import { action } from "mobx";
import axiosInstance from "../../../stores/GatewayManager/ForgeAxiosInstance";
import GlobalStore from "../../../stores/GlobalStore/GlobalStore";
import {      
    ISelectedGateway, 
  } from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";

/**
 * This store takes care of registerting the gateway with the tenant account.
 */
export default class GatewayRegistration extends GlobalStore {

  /**
   * Register the gateway using enrollment id,serial_number and original_ep
   * @param {ISelectedGateway} gatewayDetails
   */
  @action
  registerGateway(gatewayDetails: ISelectedGateway) {
    let envVars = this.envVariables;
    let registerGatewayURL =
      `${envVars.FCP_API_BASE_URL}${this.FORGECONNECT_BASE_URL_ENDPOINT}${gatewayDetails.projectId}` + '/gateway/' + `${gatewayDetails.gatewayId}`;
    return axiosInstance.getForgeEPMInstance()({
      url: registerGatewayURL,
      method: 'PATCH',     
      data: {
        'enrollment_identity': gatewayDetails.enrollmentIdentity,        
        'serial_number': gatewayDetails.serialNumber,
        'original_ep': gatewayDetails.originalEp,       
      }
    });
  }

  private readonly FORGECONNECT_BASE_URL_ENDPOINT = '/v1/projects/';

}
